module.exports = __webpack_public_path__ + "static/media/image_part_007.72b8900c.jpg";